import dynamic from "next/dynamic";
import Loading from "@/components/common/Loading";
import {getItemType, getPaddingsClassFromData} from "@/utils/utils";
import {CONTENT_TYPES} from "@/constants";
import TilesSquaresGridBackground from "@/components/TilesModule/variants/TilesSquaresGridBackground";

const TilesImageHeaderDescription = dynamic(() => import('@/components/TilesModule/variants/TilesImageHeaderDescription'), {loading: () => <Loading />});
const WhoHelpsTilesModule = dynamic(() => import('@/components/TilesModule/variants/WhoHelpsTilesModule'), {loading: () => <Loading />});
const TilesSimple = dynamic(() => import('@/components/TilesModule/variants/TilesSimple'), {loading: () => <Loading />});
const TilesFilesModule = dynamic(() => import('@/components/TilesModule/variants/TilesFilesModule'), {loading: () => <Loading />});
const HowWeHelp = dynamic(() => import('@/components/TilesModule/variants/HowWeHelp'), {loading: () => <Loading />});
const TilesRectangleGrid = dynamic(() => import('@/components/TilesModule/variants/TilesRectangleGrid'), {loading: () => <Loading />});
const TilesImageHeaderTextButton = dynamic(() => import('@/components/TilesModule/variants/TilesImageHeaderTextButton'), {loading: () => <Loading />});
const TilesRectangleGridAdditionalTopSection = dynamic(() => import('@/components/TilesModule/variants/TilesRectangleGridAdditionalTopSection'), {loading: () => <Loading />});
const TilesBlockBeWithUsTile = dynamic(() => import('@/components/TilesModule/variants/TilesBlockBeWithUsTile'), {loading: () => <Loading />});
const TilesBlockHeaderDescriptionIrregular = dynamic(() => import('@/components/TilesModule/variants/TilesBlockHeaderDescriptionIrregular'), {loading: () => <Loading />});
const TilesManagement = dynamic(() => import('@/components/TilesModule/variants/TilesManagement'), {loading: () => <Loading />});
const TilesLogo = dynamic(() => import('@/components/TilesModule/variants/TilesLogo'), {loading: () => <Loading />});
const TilesContactCards = dynamic(() => import('@/components/TilesModule/variants/TilesContactCards'), {loading: () => <Loading />});
const TilesBlockImagesNavigation = dynamic(() => import('@/components/TilesModule/variants/TilesBlockImagesNavigation'), {loading: () => <Loading />});
const TilesContactCardsSimple = dynamic(() => import('@/components/TilesModule/variants/TilesContactCardsSimple'), {loading: () => <Loading />});

function getTilesComponent(data) {
	const typename = getItemType(data?.variant)
	const paddings = getPaddingsClassFromData(data)
	const headerDescription = data?.headerDescription || null
	const variantData = data?.variant || {}
	const tilesModuleId = data?.id || '';
	switch (typename) {
		case CONTENT_TYPES.TILES_BLOCK_IMAGE_HEADER_DESCRIPTION:
			return <TilesImageHeaderDescription data={variantData} paddings={paddings} headerDescription={headerDescription}/>
		case CONTENT_TYPES.TILES_BLOCK_WHO_HELP:
			return <WhoHelpsTilesModule data={variantData} paddings={paddings} headerDescription={headerDescription}/>
		case CONTENT_TYPES.TILES_BLOCK_SIMPLE:
			return <TilesSimple data={variantData} paddings={paddings} headerDescription={headerDescription}/>
		case CONTENT_TYPES.TILES_BLOCK_FILE:
			return <TilesFilesModule data={variantData} paddings={paddings} headerDescription={headerDescription}/>
		case CONTENT_TYPES.TILES_BLOCK_HOW_WE_HELP:
			return <HowWeHelp data={variantData} paddings={paddings} headerDescription={headerDescription}/>
		case CONTENT_TYPES.TILES_BLOCK_RECTANGLE_GRID:
			return <TilesRectangleGrid data={variantData} paddings={paddings} headerDescription={headerDescription}/>
		case CONTENT_TYPES.TILES_BLOCK_IMAGE_HEADER_TEXT_BUTTON:
			return <TilesImageHeaderTextButton data={variantData} paddings={paddings} tilesModuleId={tilesModuleId} headerDescription={headerDescription}/>
		case CONTENT_TYPES.TILES_BLOCK_RECTANGLE_GRID_ADDITIONAL_TOP_SECTION:
			return <TilesRectangleGridAdditionalTopSection data={variantData}/>
		case CONTENT_TYPES.TILES_BLOCK_BE_WITH_US_TILE:
			return <TilesBlockBeWithUsTile data={variantData} paddings={paddings} headerDescription={headerDescription}/>
		case CONTENT_TYPES.TILES_BLOCK_HEADER_DESCRIPTION_IRREGULAR:
			return <TilesBlockHeaderDescriptionIrregular data={variantData} paddings={paddings} headerDescription={headerDescription}/>
		case CONTENT_TYPES.TILES_BLOCK_MANAGEMENT:
			return <TilesManagement data={variantData} paddings={paddings} headerDescription={headerDescription} />
		case CONTENT_TYPES.TILES_BLOCK_LOGO:
			return <TilesLogo data={variantData} paddings={paddings} headerDescription={headerDescription} />
		case CONTENT_TYPES.TILES_BLOCK_CONTACT_CARD:
			return <TilesContactCards data={variantData} paddings={paddings} headerDescription={headerDescription} />
		case CONTENT_TYPES.TILES_BLOCK_SQUARES_GRID_BACKGROUND:
			return <TilesSquaresGridBackground data={variantData} paddings={paddings} headerDescription={headerDescription} />
		case CONTENT_TYPES.TILES_BLOCK_IMAGES_NAVIGATION:
			return <TilesBlockImagesNavigation data={variantData} paddings={paddings} headerDescription={headerDescription} />
		case CONTENT_TYPES.TILES_BLOCK_CONTACT_CARDS_SIMPLE:
			return <TilesContactCardsSimple data={variantData} paddings={paddings} headerDescription={headerDescription} />
		default:
			return null
	}
}

export default function TilesModule({data}) {
	const Component = getTilesComponent(data)
	const tilesModuleId = data?.id || '';

	return <div id={tilesModuleId}>
		{Component}
	</div>;
}
